import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { ConcernsContextProvider } from '~/apps/smartsend/lib/context/ConcernsContext';
import { DownloadContextProvider } from '~/apps/smartsend/lib/context/DownloadContext';
import { SmartSendContextProvider } from '~/apps/smartsend/lib/context/SmartSendContext';
import EventEmitterRC from '~/apps/smartsend/lib/em/EventEmitterRC';
import { useAuth } from 'react-oidc-context';
import { P2GImageMessage } from '~/components/imagemessage';
import { NavigationContextProvider } from '~/components/nav/nav-context';
import { ProfileContextProvider } from '~/apps/smartsend/lib/context/ProfileContext';

// Provider/auth shell shared by both navigation experiences. The per-experience
// chrome (sidebar, banners, tasks) lives in the layout rendered into <Outlet/>:
// SmartSendLayout for the business experience, ConsumerLayout for the consumer view.
export default function Component() {
  const { isAuthenticated } = useAuth();
  return (
    <Suspense fallback={<></>}>
      {isAuthenticated ? (
        <NavigationContextProvider>
          <EventEmitterRC>
            <DownloadContextProvider>
              <SmartSendContextProvider>
                <ProfileContextProvider>
                  <ConcernsContextProvider>
                    <Outlet />
                  </ConcernsContextProvider>
                </ProfileContextProvider>
              </SmartSendContextProvider>
            </DownloadContextProvider>
          </EventEmitterRC>
        </NavigationContextProvider>
      ) : (
        <P2GImageMessage
          image="/theme/smartsend/notifications/signing-in.png"
          contentKey="image-myaccount-signing-in"
          message="Signing you in"
          showLoader
        />
      )}
    </Suspense>
  );
}

Component.displayName = 'My Account';
